import { render } from "./AboutAwards.vue?vue&type=template&id=57f05f57&scoped=true"
import script from "./AboutAwards.vue?vue&type=script&lang=js"
export * from "./AboutAwards.vue?vue&type=script&lang=js"

import "./AboutAwards.vue?vue&type=style&index=0&id=57f05f57&lang=scss&scoped=true"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f05f57"]])

export default __exports__